(function (angular) {
    // Determines whether an input element contains a valid credit card number
    angular.module('app').directive('creditCardType', function () {
            var directive =
            {
                require: 'ngModel',
                link: function (scope, elm, attrs, ctrl) {
                    ctrl.$parsers.unshift(function (value) {

                        // remove spaces and dashes from the value
                        var number = value.replace(/[ -]+/g, '');

                        // validate that the number is a valid card number
                        // documentation on the credit card validation regex can be found here:
                        // http://www.regular-expressions.info/creditcard.html

                        var creditCardValidator = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|3[47][0-9]{13}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\d{3})\d{11})$/;
                        var result = creditCardValidator.test(number);

                        ctrl.$setValidity('invalid', result);
                        return value;
                    });
                }
            };
            return directive;
        }
    );
})(angular);